import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text, Button } from '../../Atoms'; // + ButtonStep
import PageTitle from '../../Components/Dashboard/PageTitle';
import { COLOR_BUTTON } from '../../Config/Config';
import OrganismPaginatedTable from '../../Organisms/OrganismPaginatedTable/OrganismPaginatedTable';
import OrganismFilterableSelectableTable
  from '../../Organisms/OrganismFilterableSelectableTable/OrganismFilterableSelectableTable';
import { apiGetPayment } from '../../Api/Payment/Payment';

const TemplateCotisation = ({
                              columnTitles,
                              data = [],
                              methodePaiement,
                              codeMethodePaiement,
                              montantApayer,
                              montantAcompte,
                              urlPrelevement,
                            }) => {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
// Calculer les impayés
  const impayes = data.filter(item => parseFloat(item.montant) > 0);

  // Fonction pour ouvrir la modale ou rediriger vers Payzen
  const handleOpenModalPaymentInfo = async () => {
    if (impayes.length === 1) {
      // Cas d'un seul impayé : redirection directe vers Payzen
      const impaye = impayes[0];
      const dataToSend = {
        amount: parseFloat(impaye.montant),
        nbMaturities: 1,
        origin: "Web",
        paymentOrderDetails: [{
          amount: parseFloat(impaye.montant),
          codePolice: impaye.codePolice,
          idMaturity: impaye.appelcotis
        }]
      };

      try {
        const response = await apiGetPayment(dataToSend);
        if (response.paymentUrl && response.paymentUrl.length > 0) {
          window.location.href = response.paymentUrl;
        } else {
          console.error('Pas de paymentUrl dans la réponse');
          // Option : Afficher un message d'erreur à l'utilisateur ici
        }
      } catch (error) {
        console.error('Erreur lors de la création de la commande de paiement:', error);
        // Option : Afficher un message d'erreur à l'utilisateur ici
      }
    } else if (impayes.length >= 2) {
      // Fonction pour ouvrir la modale
      setShowPaymentForm(true);
    }
    // Si impayes.length === 0, rien ne se passe car le bouton est déjà masqué par la condition montantApayer > 0
  };

  return (
    <div className="template-cotisation template-scroll pl-30 pb-5">
      <div className="template-cotisation-liste pb-5">

        <PageTitle
          titleText={showPaymentForm ? "Paiement de ma cotisation" : "Mes cotisations"}
          canGoBack={false}
        />

        <div className={`d-flex ${showPaymentForm ? 'justify-content-end' : 'justify-content-between'}`}>
          {!showPaymentForm && methodePaiement && (
            <div className="align-self-center d-flex justify-content-between m-1" id="methodePaiement">
              <Text
                text="Moyen de paiement actuel : "
                type="h7"
                className="p-1"
              />
              <Text
                text={methodePaiement}
                type="h8"
                className="align-self-center p-1"
              />
            </div>
          )}
          <div
            className={`align-self-center d-flex justify-content-${!showPaymentForm && methodePaiement ? 'between' : 'end'} m-1`}
            id="montantApayer">
            <Text
              text="Montant Total à payer : "
              type="h4"
              className="p-1"
            />
            <Text
              text={`${montantApayer} €`}
              type="h4"
              className="align-self-center p-1"
            />
          </div>
        </div>

        {montantAcompte > 0 && (
          <div className="d-flex justify-content-end">
            <div className="d-flex justify-content-end m-1">
              <Text
                text="Acompte déjà payé : "
                type="h7"
                className="p-1"
              />
              <Text
                text={`${montantAcompte} €`}
                type="h8"
                className="align-self-center p-1"
              />
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end m-2 mb-10">

          {!showPaymentForm && (
            <div className="align-self-center">
              {montantApayer > 0
                ? <Button
                  text="Je règle ma facture"
                  className="button-big-round"
                  onClick={handleOpenModalPaymentInfo}
                  color={COLOR_BUTTON.SECOND_RED}
                />
                : null
              }
            </div>
          )}
        </div>

        <div className="mt-4 pt-3">
          {!showPaymentForm && (
            <div className="m-2">
              <Text
                text="Voici vos dernières échéances :"
                type="h8"
                className="mb-3"
              />
            </div>
          )}
          <div className="pb-5">
            {!showPaymentForm && (
              <OrganismPaginatedTable data={data} columnTitles={columnTitles} />
            )}
            {showPaymentForm && (
              <OrganismFilterableSelectableTable
                data={data}
                columnTitles={columnTitles}
                onSelectionChange={(data) => {
                  // Utilisez data.selectedItems pour les lignes sélectionnées
                  // Utilisez data.totals pour les montants totaux
                  // console.log('Données à envoyer à API:', data);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TemplateCotisation.propTypes = {
  columnTitles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.any,
      field: PropTypes.any
    })
  ).isRequired,
  data: PropTypes.array,
  methodePaiement: PropTypes.string.isRequired,
  codeMethodePaiement: PropTypes.string,
  montantApayer: PropTypes.number.isRequired,
  montantAcompte: PropTypes.string,
  urlPrelevement: PropTypes.string,
};

export default TemplateCotisation;
